import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { TooltipData } from 'src/containers/ProjectDiagram/types/tooltip';

export type TooltipValue = [
  TooltipData | null,
  (tooltip: TooltipData | null) => void
];

export const TooltipContext = React.createContext<TooltipValue>([null, noop]);

export const useTooltip = () => {
  const tooltip = React.useContext(TooltipContext);
  return tooltip;
};

export const useTooltipValue = (): TooltipValue => {
  const [tooltip, setTooltip] = React.useState<TooltipData | null>(null);
  return [tooltip, setTooltip];
};
